import { useMe } from "@/hooks/use-auth";
import { useWorkspaces } from "@/hooks/use-workspaces";
import logoImg from "@/logo.webp";

// ponytail: no more session-level workspace switching (canSwitchWorkspace
// roles filter per-module instead, see components/shared/workspace-filter.tsx)
// — this is just a static label of the account's home workspace now.
export function WorkspaceLabel() {
  const { data: me } = useMe();
  const { data: workspacesData } = useWorkspaces({ per_page: 100 });

  const homeWorkspace = (workspacesData?.items ?? []).find(
    (w) => w.id === me?.workspaceId,
  );

  return (
    <div className="flex items-center gap-2.5 py-0.5">
      <img
        src={logoImg}
        alt="JAM Coffee"
        className="h-9 w-auto max-w-[130px] object-contain shrink-0"
      />
      {homeWorkspace?.name && (
        <span className="text-xs font-medium text-muted-foreground truncate border-l border-border/80 pl-2">
          {homeWorkspace.name}
        </span>
      )}
    </div>
  );
}
